import { Coins, TrendingUp, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TokenCard = ({ track }) => {
  const navigate = useNavigate();
  const percentOwned = 100 - track.available_tokens;

  return (
    <div 
      className="token-card glass-card p-5 card-hover cursor-pointer"
      onClick={() => navigate(`/track/${track.id}`)}
      data-testid={`token-card-${track.id}`}
    >
      <div className="flex gap-4">
        <img 
          src={track.cover_url} 
          alt={track.title}
          className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-white truncate mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            {track.title}
          </h3>
          <p className="text-sm text-gray-400 truncate">{track.album}</p>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-white/10">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="flex items-center justify-center gap-1 text-cyan-400 mb-1">
              <Coins className="w-4 h-4" />
              <span className="font-bold token-data">${track.token_price.toFixed(2)}</span>
            </div>
            <p className="text-xs text-gray-500">Per 1%</p>
          </div>
          <div>
            <div className="flex items-center justify-center gap-1 text-purple-400 mb-1">
              <TrendingUp className="w-4 h-4" />
              <span className="font-bold token-data">{track.available_tokens}%</span>
            </div>
            <p className="text-xs text-gray-500">Available</p>
          </div>
          <div>
            <div className="flex items-center justify-center gap-1 text-pink-400 mb-1">
              <Users className="w-4 h-4" />
              <span className="font-bold token-data">{percentOwned}%</span>
            </div>
            <p className="text-xs text-gray-500">Owned</p>
          </div>
        </div>
      </div>

      {/* Progress bar */}
      <div className="mt-4">
        <div className="h-2 bg-white/10 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-purple-500 to-cyan-500"
            style={{ width: `${percentOwned}%` }}
          />
        </div>
        <p className="text-xs text-gray-500 mt-2 text-center">
          {percentOwned}% of ownership sold
        </p>
      </div>
    </div>
  );
};
